const NAMESPACE = "textConfirmationDialog";

const KEYS = {
    inputTextDoesNotMatchConfirmationMessage: "inputTextDoesNotMatchConfirmationMessage",
    inputLabelBase: "inputLabelBase"
};

const MESSAGES = {
    [KEYS.inputTextDoesNotMatchConfirmationMessage]: {
        value: "Input does not match text confirmation",
        comment: "Error message to display when user input does not match confirmation"
    },
    [KEYS.inputLabelBase]: {
        value: 'To confirm, type "{requiredConfirmation}"',
        comment: "Partial confirmation input label to combine with required confirmation"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
